import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../../components/reusable/Seo/Seo.js';
import Reveal from '../../../components/ui/Reveal.js';

const LINKS = [
  { label: 'Home', href: '/' },
  { label: 'What We Do', href: '/what-we-do' },
  { label: 'About', href: '/about' },
  { label: 'Careers', href: '/careers' },
  { label: 'Contact', href: '/contact' },
];

function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" path="/404" noindex />
      <section className="pg-hero u-grain">
        <div className="pg-hero__glow" aria-hidden="true" />
        <div className="u-container pg-hero__inner">
          <Reveal>
            <span className="u-eyebrow u-eyebrow--on-dark">Error 404</span>
            <h1 className="pg-hero__title">
              We couldn&apos;t find <em>that page.</em>
            </h1>
            <p className="pg-hero__lede">
              The page you&apos;re looking for may have moved or no longer exists.
              Here are some helpful places to pick back up:
            </p>
          </Reveal>

          <Reveal delay={0.12} className="pg-hero__cta" as="nav">
            {LINKS.map((l) => (
              <Link key={l.href} to={l.href} className="btn btn--ghost-light">
                {l.label}
              </Link>
            ))}
          </Reveal>
        </div>
      </section>
    </>
  );
}

export default NotFound;
